export class SearchCriteria{
    userName: string[];
    moduleName: string = null;
    action: string = null;
    searchCriteria: string;
    ipAddress: string;
    fromDate: string;
    toDate: string;
    orderBy: string;
    pageNumber: number;
}


// WEBPACK FOOTER //
// ./src/app/modules/activity-log/entities/search-criteria.ts